import { useEffect } from 'react';
import { API_OPTIONS } from '../utils/constants'
import { useDispatch , useSelector } from 'react-redux'
import { addPopularMovie } from "../utils/movieSlice"

const usePopularMovie = () =>
{
    const dispatch = useDispatch();

    const popularMovie = useSelector((store) => store.movie.popularMovie)

  const getPopularMovies = async () => {
    const data = await fetch('https://api.themoviedb.org/3/movie/popular?page=1', API_OPTIONS);
    const json = await data.json();
    // console.log(json.results);
    dispatch(addPopularMovie(json.results));
  }

  useEffect(() => {
   !popularMovie && getPopularMovies();
  }, []);
};

export default usePopularMovie;
